import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBasecampComponent } from './simple-icons-basecamp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBasecampComponent ],
    exports:      [ SimpleIconsBasecampComponent ],
    bootstrap:    []
})
export class SimpleIconsBasecampModule {}
